module.exports = __webpack_public_path__ + "media/Instruction_003.0bc30622.mp3";